import React from "react";
import "./index.scss";

/**
 * 提交按钮
 */
export const ModalSubmitButton: React.SFC<{
  onClick: () => void;
}> = props => {
  return (
    <div className={"ModalSubmitButton"} onClick={props.onClick}>
      提交
    </div>
  );
};
